import { FC } from 'react'

import { OrderList } from '../../utils/types/buyerCatalogs'
import CatalogCardMobile from './CatalogCardMobile'

interface MobileViewCatalogListProps {
  catalogData: OrderList[]
}

const MobileViewCatalogList: FC<MobileViewCatalogListProps> = (props) => {
  const { catalogData } = props

  return (
    <>
      {catalogData.map((catalog) => (
        <CatalogCardMobile
          key={catalog.id}
          catalog={catalog}
        />
      ))}
    </>
  )
}

export default MobileViewCatalogList
